import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';

import { ESignatureIntegrationUsers } from '../../types';
import { IntegrationStateMessage } from './IntegrationMessages';
import { useIntegration } from './useIntegration.logic';
import { UserRow } from './UserRow';

export interface IntegrationUserListProps {
  data: ESignatureIntegrationUsers | undefined;
  isLoadingIntegrationUsers: boolean;
  searchKeyword?: string;
}

export const IntegrationUserList: React.FC<IntegrationUserListProps> = ({
  data,
  isLoadingIntegrationUsers,
  searchKeyword,
}) => {
  const intl = useIntl();
  const {
    selectedUsers,
    toggleUser,
    displayedUsers,
    integrationState,
    isLoading,
  } = useIntegration(data, searchKeyword);
  return (
    <ContentContainer
      loadingContent={{ isLoading: isLoading || isLoadingIntegrationUsers }}
    >
      <Layout direction="column" spacing={4}>
        {integrationState ? (
          <IntegrationStateMessage state={integrationState} />
        ) : (
          displayedUsers.map((item) => (
            <UserRow
              key={item.id}
              item={item}
              isSelected={selectedUsers.includes(item.id)}
              searchKeyword={searchKeyword}
              userName={item.resolvedUserName ?? ''}
              onToggleUser={() => toggleUser(item.id)}
            />
          ))
        )}
        {displayedUsers.length === 0 && integrationState === null && (
          <StatusMessage
            message={intl.formatMessage({
              id: 'IntegrationUserList.apiEmpty',
              defaultMessage: 'No users found',
              description:
                'When the API returns no users at all for the particular E-Signature Integration',
            })}
          />
        )}
      </Layout>
    </ContentContainer>
  );
};
